import { defineEvent } from '../types/event';
export var COUPON_MODAL_CLOSE = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
